import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const LoanSummaryFacebookLoader = ({isPageCancelLoan = false}) => {
  const milestoneCount = 10;

  return (
    <div className="min-h-screen bg-gray-50 p-6 summary-font animate-pulse">
      <div className="max-w-7xl mx-auto">
        {/* Milestone Loader */}
        {!isPageCancelLoan ? <div className="bg-white p-6 mb-6 rounded-lg shadow-sm border border-gray-100">
          <div className="relative">
            <div className="absolute left-10 right-10 top-5 h-1 bg-gray-100 z-0"></div>
            <div className="relative flex justify-between z-10">
              {[...Array(milestoneCount)].map((_, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center relative"
                  style={{ width: `${100 / milestoneCount}%` }}
                >
                  <div className="w-10 h-10 rounded-full bg-gray-200 border-2 border-gray-300"></div>
                  <div className="mt-3 w-16 h-3 bg-gray-200 rounded"></div>
                </div>
              ))}
            </div>
          </div>
        </div> : <div className="mb-6">
          <SkeletonCard height={30} />
        </div>}

        {/* Card Loaders */}
        <div className="grid_summary grid-cols-1 md:grid-cols-3 gap-6">
          {/* Left Column */}
          <div className="space-y-6">
            <SkeletonCard height={150} />
            <SkeletonCard height={150} />
          </div>

          {/* Middle Column */}
          <div className="space-y-6">
            <SkeletonCard height={150} />
            <SkeletonCard height={150} />
          </div>

          {/* Right Column */}
          <div className="space-y-6">
            <SkeletonCard height={400} />
          </div>
        </div>
      </div>
    </div>
  );
};

const SkeletonCard = ({ height = 200 }) => (
  <div className="bg-white p-6 rounded-lg shadow-sm border h-full">
    <Skeleton height={height} />
  </div>
);

export default LoanSummaryFacebookLoader;
